const STORE_REVIEWS_ENDPOINT = 'https://api-cdn.yotpo.com/v3/storefront/store'

// Every instance on the page shows the same store-wide bottomline, so share one request.
const bottomlineRequests = {}

const fetchBottomline = (appKey) => {
  if (!bottomlineRequests[appKey]) {
    bottomlineRequests[appKey] = fetch(`${STORE_REVIEWS_ENDPOINT}/${appKey}/reviews?page=1&perPage=1&sort=date`)
      .then(res => res.json())
      .then(data => data?.bottomline || null)
      .catch(error => {
        console.error('Error fetching Yotpo store bottomline:', error)
        return null
      })
  }

  return bottomlineRequests[appKey]
}

const yotpoStars = (appKey) => ({
  averageScore: 0,
  totalReview: 0,
  async init(){
    const bottomline = await fetchBottomline(appKey)

    if (!bottomline) return

    this.averageScore = Math.floor(bottomline.averageScore * 10) / 10
    this.totalReview = bottomline.totalReview
  },
  get fillWidth(){
    return `${(this.averageScore / 5) * 100}%`
  }
})

export default yotpoStars

window.addEventListener("alpine:init", ()=>{
  Alpine.data("yotpoStars", yotpoStars)
})
